export default {
  HOME: 'home',
  LOGIN: 'login',
  SIGNUP: 'signup',
  VERIFY_USER: 'verify_user',
  FORGOT_PASSWORD: 'forgot',
  FORGOT_PASSWORD_SET_PASSWORD: 'set_password',
  SET_ACCOUNT_MANAGER_PASSWORD: 'set_account_manager_password',
  WIZARD: 'wizard',
  FEEDBACK_PREVIEW: 'feedback_preview',
  PROOF_PREVIEW: 'proof_preview',
  APP: 'app',
  SURVEY: 'survey',
  SURVEY_METRICS: 'survey_metrics',
  SURVEY_CUSTOMIZE: 'survey_customize',
  SURVEY_CUSTOMIZE_NPS: 'survey_customize_nps',
  SURVEY_CUSTOMIZE_NPS_QUESTION: 'survey_customize_nps_question',
  SURVEY_CUSTOMIZE_NPS_DRIVERS: 'survey_customize_nps_drivers',
  SURVEY_CUSTOMIZE_NPS_OPEN_ENDED: 'survey_customize_nps_open_ended',
  SURVEY_CUSTOMIZE_CSAT: 'survey_customize_csat',
  SURVEY_CUSTOMIZE_CSAT_QUESTION: 'survey_customize_csat_question',
  SURVEY_CUSTOMIZE_CSAT_DRIVERS: 'survey_customize_csat_drivers',
  SURVEY_CUSTOMIZE_CSAT_OPEN_ENDED: 'survey_customize_csat_open_ended',
  SURVEY_CUSTOMIZE_CES: 'survey_customize_ces',
  SURVEY_CUSTOMIZE_CES_QUESTION: 'survey_customize_ces_question',
  SURVEY_CUSTOMIZE_CES_DRIVERS: 'survey_customize_ces_drivers',
  SURVEY_CUSTOMIZE_CES_OPEN_ENDED: 'survey_customize_ces_open_ended',
  SURVEY_APPEARANCE: 'survey_appearance',
  SURVEY_SETTINGS: 'survey_settings',
  SURVEY_CHANNELS: 'survey_channels',
  SURVEY_INTEGRATIONS: 'survey_integrations',
  SURVEY_PUBLISH: 'survey_publish',
  INSIGHTS: 'insights',
  INSIGHTS_OVERVIEW: 'insights_overview',
  INSIGHTS_METRICS: 'insights_metrics',
  INSIGHTS_METRICS_NPS: 'insights_metrics_nps',
  INSIGHTS_METRICS_NPS_SUMMARY: 'insights_metrics_nps_summary',
  INSIGHTS_METRICS_NPS_DRIVERS: 'insights_metrics_nps_drivers',
  INSIGHTS_METRICS_NPS_TRENDS: 'insights_metrics_nps_trends',
  INSIGHTS_METRICS_CSAT: 'insights_metrics_csat',
  INSIGHTS_METRICS_CSAT_SUMMARY: 'insights_metrics_csat_summary',
  INSIGHTS_METRICS_CSAT_DRIVERS: 'insights_metrics_csat_drivers',
  INSIGHTS_METRICS_CSAT_TRENDS: 'insights_metrics_csat_trends',
  INSIGHTS_METRICS_CES: 'insights_metrics_ces',
  INSIGHTS_METRICS_CES_SUMMARY: 'insights_metrics_ces_summary',
  INSIGHTS_METRICS_CES_DRIVERS: 'insights_metrics_ces_drivers',
  INSIGHTS_METRICS_CES_TRENDS: 'insights_metrics_ces_trends',
  INSIGHTS_RESPONSES: 'insights_responses',
  ACCOUNTS: 'accounts',
  ACCOUNTS_TEAM: 'accounts_team',
  ACCOUNTS_BILLING: 'accounts_billing',
  ACCOUNTS_BILLING_CURRENT: 'accounts_billing_current',
  ACCOUNTS_BILLING_PLANS: 'accounts_billing_plans',
  ACCOUNTS_BILLING_INVOICES: 'accounts_plans_invoice',
  ACCOUNTS_BUSINESS_CATEGORY: 'accounts_business_category',
  ACCOUNTS_STATS: 'accounts_stats',
  ACCOUNTS_PROFILE_VIEW: 'accounts_profile_view',
  ACCOUNTS_PROFILE_DETAILS: 'accounts_profile_details',
  ACCOUNTS_PROFILE_CHANGE_PASSWORD: 'accounts_profile_change_password',
  PROOF: 'proof',
  PROOF_APPEARANCE: 'proof_appearance',
  PROOF_CARDS: 'proof_cards',
  PROOF_CARDS_NPS: 'proof_cards_nps',
  PROOF_CARDS_CSAT: 'proof_cards_csat',
  PROOF_CARDS_CES: 'proof_cards_ces',
  PROOF_SETTINGS: 'proof_settings',
  PROOF_INTEGRATIONS: 'proof_integrations',
  PROOF_PUBLISH: 'proof_copy_code',
  SCRIPT: 'script',
  SCRIPT_COPY: 'script_copy',
  HELP: 'help',
  EXP_MAP: 'exp_map',
  OAUTH_GRANT: 'oauth_grant',
  DEMO: 'demo'
}
